var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-qrcode-page",class:{'clear-header':_vm.isWechatBrowser}},[(!_vm.isWechatBrowser)?_c('my-header',{staticClass:"top-title",attrs:{"title":"咨询","showBack":true}}):_vm._e(),_c('img',{staticClass:"img-qrcode",attrs:{"src":_vm.shopQrcode}}),_c('div',[_vm._v("点击图片进行查看或者保存到本地")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }